<ng-container *nzModalTitle>
  {{ 'ADD_PHOTO' | translate }}
</ng-container>

<section [ngSwitch]="mode">
  <app-lot-add-photo-modal-upload-view
    *ngSwitchCase="'upload'"
    [initialImages]="images"
    [noAuctionList]="noAuctionList"
    [grid]="grid"
    [itemHeightPx]="itemHeightPx"
    (sort)="mode = 'sort'"
    (images)="images = $event"
    (uploading)="uploading = $event"
  ></app-lot-add-photo-modal-upload-view>

  <app-lot-add-photo-modal-sort-view
    *ngSwitchCase="'sort'"
    [initialImages]="images"
    [noAuctionList]="noAuctionList"
    [grid]="grid"
    [itemHeightPx]="itemHeightPx"
    (completed)="sortCompleted($event)"
  ></app-lot-add-photo-modal-sort-view>
</section>

<section>
  <nz-space>
    <span *nzSpaceItem>{{ 'USE_WATERMARK' | translate }}:</span>
    <nz-switch *nzSpaceItem [(ngModel)]="useWatermark"></nz-switch>
  </nz-space>
</section>

<section>
  <nz-space>
    <span *nzSpaceItem>{{ 'NO_AUCTION_LIST' | translate }}:</span>
    <nz-switch *nzSpaceItem [(ngModel)]="noAuctionList"></nz-switch>
  </nz-space>
</section>

<ng-container *nzModalFooter>
  <nz-space>
    <button
      *nzSpaceItem
      nz-button
      nzType="primary"
      [nzLoading]="saving$ | async"
      [disabled]="uploading || mode === 'sort'"
      (click)="save()"
    >
      {{ 'SAVE' | translate }}
    </button>
    <button *nzSpaceItem nz-button [disabled]="saving$ | async" (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </button>
  </nz-space>
</ng-container>
